module.exports = __webpack_public_path__ + "static/img/bg.5fd4ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/bg.png
// module id = WE+o
// module chunks = 2